<iconify-icon [icon]="icon" [class]="class"></iconify-icon>
